module.exports = __webpack_public_path__ + "assets/img/bmapimg.f2f219fe.jpg";